<template>
  <v-dialog v-model="dialog" max-width="850" scrollable eager persistent>
    <v-card class="rounded-xl elevation-3" :loading="loading">
      <v-card-title class="text-h6 font-weight-bold pt-6 px-8 grey--text text--darken-3">
        <v-icon left color="teal darken-4" class="mr-3">mdi-account-edit</v-icon>
        Thông tin nhân viên
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false, itemCode = null" color="grey">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs v-model="tab" class="px-4" color="teal darken-4" slider-size="3">
          <v-tab class="font-weight-bold" style="letter-spacing: 0.05em;">
            THÔNG TIN CÁ NHÂN 
            <v-icon small color="error" class="ml-2" v-show="isValid==false && showTabValid==true">mdi-alert-circle</v-icon>
          </v-tab>
          <v-tab class="font-weight-bold" style="letter-spacing: 0.05em;">NGƯỜI THÂN</v-tab>
      </v-tabs>

      <v-divider></v-divider>
      <v-card-text class="text--primary">
          <v-tabs-items v-model="tab">
              <v-tab-item eager>
                  <v-form v-model="isValid" @submit.prevent="submitForm" ref="update_info_form" id="update_info_form">
                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 px-2 d-flex align-center">
                      <v-icon small color="teal darken-4" class="mr-2">mdi-card-account-details</v-icon>
                      THÔNG TIN CƠ BẢN
                      <v-spacer></v-spacer>
                      <template v-if="isConfirmView && !!itemCode">
                        <v-btn icon small color="blue darken-3" @click="isEditingPersonal = true" v-if="!isEditingPersonal">
                           <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn small color="green darken-3" dark @click="savePersonal" v-if="isEditingPersonal" class="ml-2 rounded-pill" :loading="isSavingPersonal">
                           <v-icon left>mdi-content-save</v-icon> Lưu
                        </v-btn>
                        <v-btn icon small color="grey" @click="isEditingPersonal = false" v-if="isEditingPersonal" class="ml-1">
                           <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                    </div>
                    
                    <v-card outlined rounded="xl" class="grey lighten-5 mb-6">
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col cols="12" md="3">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Mã NS:</label>
                              <div class="text-h6 font-weight-bold teal--text text--darken-3 ml-1">{{form.employeeCode || '--'}}</div>
                          </v-col>
                          <v-col cols="12" md="3">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Ngày vào làm:</label>
                              <div class="text-h6 font-weight-bold teal--text text--darken-3 ml-1">{{ $formatter.formatDate(hireDate, 'DD/MM/YYYY') || '--' }}</div>
                          </v-col>
                          <v-col cols="12" md="6">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">
                                Họ & tên: 
                                <v-tooltip bottom v-if="form.employeeName != originForm.employeeName">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="error" v-bind="attrs" v-on="on" small class="ml-1">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  <span>Dữ liệu gốc: {{originForm.employeeName}}</span>
                                </v-tooltip>
                              </label>
                              <v-text-field v-model="form.employeeName" dense outlined hide-details="auto" class="rounded-lg" :background-color="(isConfirmView && !isEditingPersonal) ? 'grey lighten-4' : 'white'" :rules="[v => !!v || 'Hãy nhập dữ liệu này']" :readonly="isConfirmView && !isEditingPersonal" :filled="isConfirmView && !isEditingPersonal"></v-text-field>
                          </v-col>
                          
                          <v-col cols="12" md="3">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Giới tính:</label>
                              <v-select :items="[
                                {text: 'Nam', value: true},
                                {text: 'Nữ', value: false},
                              ]" v-model="form.gender" dense outlined hide-details class="rounded-lg" :background-color="(isConfirmView && !isEditingPersonal) ? 'grey lighten-4' : 'white'" :rules="[v => v!=null|| 'Hãy nhập dữ liệu này']" :readonly="isConfirmView && !isEditingPersonal" :filled="isConfirmView && !isEditingPersonal"></v-select>
                          </v-col>
                          <v-col cols="12" md="3">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Ngày sinh:</label>
                              <v-text-field type="date" v-model="form.birthday" dense outlined hide-details="auto" class="rounded-lg" :background-color="(isConfirmView && !isEditingPersonal) ? 'grey lighten-4' : 'white'" :rules="[v => !!v || 'Hãy nhập dữ liệu này']" :readonly="isConfirmView && !isEditingPersonal" :filled="isConfirmView && !isEditingPersonal"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">SĐT:</label>
                              <v-text-field v-model="form.phoneNumber" dense outlined hide-details="auto" class="rounded-lg" :background-color="(isConfirmView && !isEditingPersonal) ? 'grey lighten-4' : 'white'" :rules="[v => !!v || 'Hãy nhập dữ liệu này']" :readonly="isConfirmView && !isEditingPersonal" :filled="isConfirmView && !isEditingPersonal"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Email:</label>
                              <v-text-field v-model="form.email" dense outlined hide-details="auto" class="rounded-lg" :background-color="(isConfirmView && !isEditingPersonal) ? 'grey lighten-4' : 'white'" placeholder="example@gmail.com"
                                :rules="[
                                  v => !!v || 'Hãy nhập email',
                                  v => /.+@.+\..+/.test(v) || 'Email không hợp lệ'
                                ]"
                                :readonly="isConfirmView && !isEditingPersonal"
                                :filled="isConfirmView && !isEditingPersonal"
                              ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 mt-8 px-2 d-flex align-center">
                      <v-icon small color="teal darken-4" class="mr-2">mdi-card-bulleted</v-icon>
                      CĂN CƯỚC CÔNG DÂN
                      <v-spacer></v-spacer>
                      <template v-if="isConfirmView && !!itemCode">
                        <v-btn icon small color="blue darken-3" @click="isEditingIdInfo = true" v-if="!isEditingIdInfo">
                           <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn small color="green darken-3" dark @click="saveIdInfo" v-if="isEditingIdInfo" class="ml-2 rounded-pill" :loading="isSavingIdInfo">
                           <v-icon left>mdi-content-save</v-icon> Lưu
                        </v-btn>
                        <v-btn icon small color="grey" @click="isEditingIdInfo = false" v-if="isEditingIdInfo" class="ml-1">
                           <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                    </div>
                    
                    <v-card outlined rounded="xl" class="grey lighten-5 mb-6">
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col cols="12" md="6">
                              <v-sheet color="teal lighten-5" height="180" class="rounded-xl d-flex align-center justify-center mb-4 elevation-0 border-light" style="border: 2px dashed #B2DFDB !important;" v-if="!form.idFrontImageUrl && !form.idFrontImageBase64.base64">
                                  <v-avatar color="white" size="84" class="elevation-1">
                                      <v-icon color="teal lighten-1" size="48">mdi-card-account-details-outline</v-icon>
                                  </v-avatar>
                              </v-sheet>
                              <v-img contain class="rounded-xl mx-auto mb-4 elevation-2 white" :src="'data:image/jpeg;charset=utf-8;base64,'+form.idFrontImageBase64.base64" v-else-if="form.idFrontImageBase64.base64 && !form.idFrontImageUrl" max-height="180" aspect-ratio="1.6"></v-img>
                              <v-img contain class="rounded-xl mx-auto mb-4 elevation-2 white cursor-pointer" v-else :src="form.idFrontImageUrl" aspect-ratio="1.6" @click="imgViewer=true, imgSrc = form.idFrontImageUrl"></v-img>
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase text-center">Mặt trước CCCD</label>
                              <v-file-input v-show="!itemCode || isEditingIdInfo" prepend-icon="" v-model="idFrontImageFile" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => (!!v || !!form.idFrontImageUrl) || 'Hãy chọn ảnh mặt trước']"></v-file-input>
                          </v-col>
                          <v-col cols="12" md="6">
                              <v-sheet color="teal lighten-5" height="180" class="rounded-xl d-flex align-center justify-center mb-4 elevation-0 border-light" style="border: 2px dashed #B2DFDB !important;" v-if="!form.idBackImageUrl && !form.idBackImageBase64.base64">
                                  <v-avatar color="white" size="84" class="elevation-1">
                                      <v-icon color="teal lighten-1" size="48">mdi-card-account-mail-outline</v-icon>
                                  </v-avatar>
                              </v-sheet>
                              <v-img contain class="rounded-xl mx-auto mb-4 elevation-2 white" :src="'data:image/jpeg;charset=utf-8;base64,'+form.idBackImageBase64.base64" v-else-if="form.idBackImageBase64.base64 && !form.idBackImageUrl" max-height="180" aspect-ratio="1.6"></v-img>
                              <v-img contain class="rounded-xl mx-auto mb-4 elevation-2 white cursor-pointer" v-else :src="form.idBackImageUrl" aspect-ratio="1.6" @click="imgViewer=true, imgSrc = form.idBackImageUrl"></v-img>
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase text-center">Mặt sau CCCD</label>
                              <v-file-input v-show="!itemCode || isEditingIdInfo" prepend-icon="" v-model="idBackImageFile" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => (!!v || !!form.idBackImageUrl) || 'Hãy chọn ảnh mặt sau']"></v-file-input>
                          </v-col>
                          
                          <v-col cols="12" md="4">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Số CCCD:</label>
                              <v-text-field v-model="form.idNumber" dense outlined hide-details="auto" class="rounded-lg" :background-color="(isConfirmView && !isEditingIdInfo) ? 'grey lighten-4' : 'white'" :readonly="isConfirmView && !isEditingIdInfo" :filled="isConfirmView && !isEditingIdInfo" :rules="[v => !!v || 'Hãy nhập số CCCD']"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Ngày cấp:</label>
                              <v-text-field type="date" v-model="form.idDate" dense outlined hide-details="auto" class="rounded-lg" :background-color="(isConfirmView && !isEditingIdInfo) ? 'grey lighten-4' : 'white'" :readonly="isConfirmView && !isEditingIdInfo" :filled="isConfirmView && !isEditingIdInfo" :rules="[v => !!v || 'Hãy nhập ngày cấp']"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Nơi cấp:</label>
                              <v-autocomplete v-model="form.idPlace" :items="idPlaces" dense outlined hide-details="auto" class="rounded-lg" :background-color="(isConfirmView && !isEditingIdInfo) ? 'grey lighten-4' : 'white'" :readonly="isConfirmView && !isEditingIdInfo" :filled="isConfirmView && !isEditingIdInfo" :rules="[v => !!v || 'Hãy nhập nơi cấp']"></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 mt-8 px-2 d-flex align-center">
                      <v-icon small color="teal darken-4" class="mr-2">mdi-home-map-marker</v-icon>
                      ĐỊA CHỈ THƯỜNG TRÚ
                    </div>
                    
                    <v-card outlined rounded="xl" class="grey lighten-5 mb-6">
                      <v-tabs background-color="grey lighten-4" color="teal darken-4">
                        <v-tab class="font-weight-bold caption">Theo tỉnh thành mới</v-tab>
                        <v-tab class="font-weight-bold caption">Theo tỉnh thành cũ</v-tab>

                        <v-tab-item class="grey lighten-5">
                          <v-card-text class="pa-6">
                            <v-row>
                              <v-col cols="12" md="4">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Thành phố/Tỉnh:</label>
                                  <v-autocomplete v-model="form.newCityId" :items="altCities" item-text="name" item-value="id" @change="fetchAltWards1(false)"
                                  dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="4">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Phường/Xã/Quận:</label>
                                  <v-autocomplete v-model="form.newWardId" :items="altWards" item-text="name" item-value="id"
                                  dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="4">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Địa chỉ cụ thể:</label>
                                  <v-text-field v-model="form.address1" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-tab-item>

                        <v-tab-item class="grey lighten-5">
                           <v-card-text class="pa-6">
                            <v-row>
                              <v-col cols="12" md="3">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Thành phố/Tỉnh:</label>
                                  <v-autocomplete v-model="form.city1Code" :items="cities" item-text="name" item-value="code" @change="fetchDistrict"
                                  dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="3">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Quận/Huyện:</label>
                                  <v-autocomplete v-model="form.district1Code" :items="districts" item-text="name" item-value="code" @change="fetchWard"
                                  dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="3">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Phường/Xã:</label>
                                  <v-autocomplete v-model="form.ward1Code" :items="wards" item-text="name" item-value="code"
                                  dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="3">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Địa chỉ:</label>
                                  <v-text-field v-model="form.address1" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-text-field>
                              </v-col>
                            </v-row>
                           </v-card-text>
                        </v-tab-item>
                      </v-tabs>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 mt-8 px-2 d-flex align-center">
                      <v-icon small color="teal darken-4" class="mr-2">mdi-school</v-icon>
                      HỌC VẤN
                    </div>
                    
                    <v-card outlined rounded="xl" class="grey lighten-5 mb-6">
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col cols="12" md="6">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Trình độ:</label>
                              <v-autocomplete v-model="form.educationLevelCode" :items="educationLevels" item-text="name" item-value="code" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Chuyên ngành:</label>
                              <v-autocomplete v-model="form.educationMajorCode" :items="educationMajors" item-text="name" item-value="code" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Cơ sở đào tạo:</label>
                              <v-autocomplete v-model="form.universityCode" :items="universities" item-text="name" item-value="code" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Trạng thái tốt nghiệp:</label>
                              <v-select v-model="form.graduateStatus" :items="[
                                { text: 'Đã tốt nghiệp', value: 1},
                                { text: 'Chưa tốt nghiệp', value: 0},
                              ]" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => v!=null || 'Hãy nhập dữ liệu này']"></v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Chứng chỉ dược:</label>
                              <v-select v-model="form.hasPharmaCert" :items="[
                                { text: 'Đại học', value: 'DH'},
                                { text: 'Cao đẳng', value: 'CD'},
                                { text: 'Không', value: 'KHONG'},
                              ]" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-select>
                          </v-col>
                          <v-col cols="12" md="6" v-show="form.hasPharmaCert != 'KHONG'">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Đính kèm chứng chỉ:</label>
                              <file-upload v-model="form.pharmaCertUrl" label="" :outlined="true" :dense="true" class="rounded-lg white"></file-upload>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 mt-8 px-2 d-flex align-center">
                      <v-icon small color="teal darken-4" class="mr-2">mdi-information-outline</v-icon>
                      THÔNG TIN CHI TIẾT
                    </div>
                    
                    <v-card outlined rounded="xl" class="grey lighten-5 mb-6">
                      <v-card-text class="pa-6">
                        <v-row>
                            <v-col cols="12" md="4">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">SĐT Khẩn cấp:</label> 
                                <v-text-field v-model="form.emergencyNumber" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Tình trạng hôn nhân:</label>
                                <v-select v-model="form.maritalStatus" :items="marriages" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn tình trạng']"></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Quốc tịch:</label>
                                <v-select v-model="form.originCode" :items="origins" item-value="code" item-text="name" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn quốc tịch']"></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Tôn giáo:</label>
                                <v-autocomplete v-model="form.religionCode" :items="religions" item-text="name" item-value="code" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn tôn giáo']"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Dân tộc:</label>
                                <v-autocomplete v-model="form.ethnicityCode" :items="ethnicities" item-text="name" item-value="code" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn dân tộc']"></v-autocomplete>
                            </v-col>
                            
                            <v-col cols="12" md="6" v-show="REQUIRE_RELIGION.includes(form.religionCode)">
                                <v-sheet color="teal lighten-5" height="180" class="rounded-xl d-flex align-center justify-center mb-4 elevation-0 border-light" style="border: 2px dashed #B2DFDB !important;" v-if="!form.religionImageUrl">
                                    <v-avatar color="white" size="84" class="elevation-1">
                                        <v-icon color="teal lighten-1" size="48">mdi-book-education-outline</v-icon>
                                    </v-avatar>
                                </v-sheet>
                                <v-img contain class="rounded-xl mx-auto mb-4 elevation-2 white cursor-pointer" v-else :src="form.religionImageUrl" aspect-ratio="1.6" @click="imgViewer=true, imgSrc = form.religionImageUrl"></v-img>
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase text-center">Hình ảnh tôn giáo</label>
                                <v-file-input v-show="!itemCode" prepend-icon="" v-model="religionImageFile" dense outlined hide-details="auto" class="rounded-lg" background-color="white"></v-file-input>
                            </v-col>
                            <v-col cols="12" md="6" v-show="REQUIRE_MARITAL.includes(form.maritalStatus)">
                                <v-sheet color="teal lighten-5" height="180" class="rounded-xl d-flex align-center justify-center mb-4 elevation-0 border-light" style="border: 2px dashed #B2DFDB !important;" v-if="!form.maritalImageUrl">
                                    <v-avatar color="white" size="84" class="elevation-1">
                                        <v-icon color="teal lighten-1" size="48">mdi-file-certificate-outline</v-icon>
                                    </v-avatar>
                                </v-sheet>
                                <v-img contain class="rounded-xl mx-auto mb-4 elevation-2 white cursor-pointer" v-else :src="form.maritalImageUrl" aspect-ratio="1.6" @click="imgViewer=true, imgSrc = form.maritalImageUrl"></v-img>
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase text-center">Hình ảnh hôn nhân</label>
                                <v-file-input v-show="!itemCode" prepend-icon="" v-model="maritalStatusImageFile" dense outlined hide-details="auto" class="rounded-lg" background-color="white"></v-file-input>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 mt-8 px-2 d-flex align-center">
                      <v-icon small color="teal darken-4" class="mr-2">mdi-map-marker-outline</v-icon>
                      ĐỊA CHỈ TẠM TRÚ
                    </div>
                    
                    <v-card outlined rounded="xl" class="grey lighten-5 mb-6">
                      <v-tabs background-color="grey lighten-4" color="teal darken-4">
                        <v-tab class="font-weight-bold caption">Theo tỉnh thành mới</v-tab>
                        <v-tab class="font-weight-bold caption">Theo tỉnh thành cũ</v-tab>

                        <v-tab-item class="grey lighten-5">
                          <v-card-text class="pa-6">
                            <v-row>
                              <v-col cols="12" md="4">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Thành phố/Tỉnh:</label>
                                  <v-autocomplete v-model="form.newCityId2" :items="altCities" item-text="name" item-value="id" @change="fetchAltWards2(false)"
                                  dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn thành phố']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="4">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Phường/Xã/Quận:</label>
                                  <v-autocomplete v-model="form.newWardId2" :items="altWards2" item-text="name" item-value="id"
                                  dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn phường xã']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="4">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Địa chỉ cụ thể:</label>
                                  <v-text-field v-model="form.address2" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập địa chỉ']"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-tab-item>

                        <v-tab-item class="grey lighten-5">
                          <v-card-text class="pa-6">
                             <v-row>
                              <v-col cols="12" md="3">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Thành phố/Tỉnh:</label>
                                  <v-autocomplete v-model="form.city2Code" :items="cities2" item-text="name" item-value="code" @change="fetchDistrict2"
                                  dense outlined hide-details="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn tỉnh']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="3">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Quận/Huyện:</label>
                                  <v-autocomplete v-model="form.district2Code" :items="districts2" item-text="name" item-value="code" @input="fetchWard2"
                                  dense outlined hide-details ="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn quận']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="3">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Phường/Xã:</label>
                                  <v-autocomplete v-model="form.ward2Code" :items="wards2" item-text="name" item-value="code"
                                  dense outlined hide-details ="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy chọn phường']"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="3">
                                  <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Địa chỉ:</label>
                                  <v-text-field v-model="form.address2" dense outlined hide-details ="auto" class="rounded-lg" background-color="white" :rules="[v => !!v || 'Hãy nhập địa chỉ']"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-tab-item>
                      </v-tabs>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 mt-8 px-2 d-flex align-center">
                      <v-icon small color="teal darken-4" class="mr-2">mdi-bank</v-icon>
                      TÀI KHOẢN NGÂN HÀNG & THUẾ
                    </div>
                    
                    <v-card outlined rounded="xl" class="grey lighten-5 mb-6">
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col cols="12" md="6">
                              <v-sheet color="teal lighten-5" height="180" class="rounded-xl d-flex align-center justify-center mb-4 elevation-0 border-light" style="border: 2px dashed #B2DFDB !important;" v-if="!form.bankImageUrl">
                                  <v-avatar color="white" size="84" class="elevation-1">
                                      <v-icon color="teal lighten-1" size="48">mdi-bank-outline</v-icon>
                                  </v-avatar>
                              </v-sheet>
                              <v-img contain class="rounded-xl mx-auto mb-4 elevation-2 white cursor-pointer" v-else :src="form.bankImageUrl" aspect-ratio="1.6" @click="imgViewer=true, imgSrc = form.bankImageUrl"></v-img>
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase text-center">Ảnh tài khoản ngân hàng</label>
                              <v-file-input v-show="!itemCode" v-model="bankImageFile" dense outlined hide-details="auto" class="rounded-lg" background-color="white"></v-file-input>
                          </v-col>
                          <v-col cols="12" md="6">
                              <v-row>
                                <v-col cols="12">
                                    <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Ngân hàng:</label>
                                    <v-autocomplete v-model="form.bankCode" :items="banks" item-text="name" item-value="code"
                                    dense outlined hide-details ="auto" class="rounded-lg" background-color="white"></v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Số tài khoản:</label>
                                    <v-text-field v-model="form.bankNumber" dense outlined hide-details="auto" class="rounded-lg" background-color="white"></v-text-field>
                                </v-col>
                              </v-row>
                          </v-col>
                          
                          <v-col cols="12"><v-divider class="my-2"></v-divider></v-col>

                          <v-col cols="12" md="6">
                              <div class="d-flex align-center justify-space-between mb-1">
                                <label class="caption font-weight-bold grey--text text--darken-1 text-uppercase">Mã số thuế:</label>
                                <a href="https://canhan.gdt.gov.vn/ICanhan/Request?&dse_sessionId=32BsIb-n0FAxIZTJDtYQ8m3&dse_applicationId=-1&dse_pageId=117&dse_operationName=retailIndexProc&dse_errorPage=error_page.jsp&dse_processorState=initial&dse_nextEventName=start"
                                    class="caption teal--text text--darken-3 font-weight-bold text-decoration-underline" target="_blank"
                                >Tra cứu MST <v-icon x-small color="teal">mdi-open-in-new</v-icon></a>
                              </div>
                              <v-text-field v-model="form.taxNumber" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :disabled="noTaxNumber" :placeholder="noTaxNumber ? 'Không có mã số thuế' : 'Nhập MST'"></v-text-field>
                              <v-checkbox dense v-model="noTaxNumber" class="mt-1" color="teal darken-4">
                                <template v-slot:label>
                                  <span class="caption grey--text text--darken-2">Chưa có mã số thuế</span>
                                </template>
                              </v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Mã BHXH:</label>
                              <v-text-field v-model="form.insuranceNumber" dense outlined hide-details="auto" class="rounded-lg" background-color="white" :disabled="noInsuranceNumber" :placeholder="noInsuranceNumber ? 'Không có mã BHXH' : 'Nhập số BHXH'"></v-text-field>
                              <v-checkbox dense v-model="noInsuranceNumber" class="mt-1" color="teal darken-4">
                                <template v-slot:label>
                                  <span class="caption grey--text text--darken-2">Chưa có mã BHXH</span>
                                </template>
                              </v-checkbox>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 mt-8 px-2 d-flex align-center">
                      <v-icon small color="teal darken-4" class="mr-2">mdi-folder-account</v-icon>
                      HỒ SƠ TUYỂN DỤNG ĐÍNH KÈM
                    </div>
                    
                    <v-card outlined rounded="xl" class="grey lighten-5 mb-8">
                      <v-card-text class="pa-8">
                        <!-- Nhóm hồ sơ chính -->
                        <div class="d-flex align-center mb-6">
                            <v-avatar color="teal lighten-5" size="32" class="mr-3">
                                <span class="teal--text text--darken-4 font-weight-bold body-2">1</span>
                            </v-avatar>
                            <span class="subtitle-1 font-weight-bold grey--text text--darken-3">GIẤY TỜ HÀNH CHÍNH</span>
                        </div>
                        
                        <v-row class="mb-6">
                          <v-col cols="12" md="6" class="pb-2">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">
                                Đơn xin việc <span class="red--text ml-1" v-if="isRequireUpload">*</span>
                              </label>
                              <file-upload v-model="form.applicationUrl" accept="image/*,application/pdf" outlined dense hide-details="auto" input-class="rounded-lg" background-color="white" prepend-icon="" prepend-inner-icon="mdi-file-document" :rules="isRequireUpload ? [() => !!form.applicationUrl || 'Vui lòng đính kèm đơn xin việc'] : []"></file-upload>
                          </v-col>

                          <v-col cols="12" md="6" class="pb-2">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">
                                CV / Sơ yếu lý lịch <span class="red--text ml-1" v-if="isRequireUpload">*</span>
                              </label>
                              <file-upload v-model="form.cvUrl" accept="image/*,application/pdf" outlined dense hide-details="auto" input-class="rounded-lg" background-color="white" prepend-icon="" prepend-inner-icon="mdi-account-box" :rules="isRequireUpload ? [() => !!form.cvUrl || 'Vui lòng đính kèm CV'] : []"></file-upload>
                          </v-col>

                          <v-col cols="12" md="6" class="pb-2">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">
                                Hộ khẩu / Tạm trú <span class="red--text ml-1" v-if="isRequireUpload">*</span>
                              </label>
                              <file-upload v-model="form.residenceUrl" accept="image/*,application/pdf" outlined dense hide-details="auto" input-class="rounded-lg" background-color="white" prepend-icon="" prepend-inner-icon="mdi-home-account" :rules="isRequireUpload ? [() => !!form.residenceUrl || 'Vui lòng đính kèm sổ hộ khẩu'] : []"></file-upload>
                          </v-col>

                          <v-col cols="12" md="6" class="pb-2">
                              <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">
                                BHYT / BHXH <span class="red--text ml-1" v-if="isRequireUpload">*</span>
                              </label>
                              <file-upload v-model="form.insuranceUrl" accept="image/*,application/pdf" outlined dense hide-details="auto" input-class="rounded-lg" background-color="white" prepend-icon="" prepend-inner-icon="mdi-card-bulleted" :rules="isRequireUpload ? [() => !!form.insuranceUrl || 'Vui lòng đính kèm thẻ bảo hiểm'] : []"></file-upload>
                          </v-col>
                        </v-row>

                        <!-- Nhóm bằng cấp / chứng chỉ -->
                        <v-divider class="my-8"></v-divider>

                        <div class="d-flex align-center mb-6">
                            <v-avatar color="teal lighten-5" size="32" class="mr-3">
                                <span class="teal--text text--darken-4 font-weight-bold body-2">2</span>
                            </v-avatar>
                            <span class="subtitle-1 font-weight-bold grey--text text--darken-3">BẰNG CẤP & CHỨNG CHỈ</span>
                            <v-spacer></v-spacer>
                            <v-chip v-if="isRequireUpload" x-small color="red lighten-5" class="red--text px-2 font-weight-bold border-red">
                                <v-icon x-small color="red" class="mr-1">mdi-alert-circle</v-icon> Yêu cầu tối thiểu 1
                            </v-chip>
                        </div>

                        <v-row>
                            <v-col cols="12" md="4" sm="6" v-for="i in 5" :key="i" class="pb-2">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">
                                    Chứng chỉ {{ i }} <span class="red--text" v-if="isRequireUpload && i==1">*</span>
                                </label>
                                <file-upload v-model="form['educationCert' + i + 'Url']" accept="image/*,application/pdf" outlined dense hide-details="auto" input-class="rounded-lg" background-color="white" prepend-icon="" prepend-inner-icon="mdi-school" :rules="isRequireUpload && i==1 ? [() => !!form.educationCert1Url || 'Yêu cầu đính kèm'] : []"></file-upload>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-form>
              </v-tab-item>
              <v-tab-item eager>
                <!-- <v-subheader class="text-subtitle-1 font-weight-bold" v-if="!form.updatingFamily">DỮ LIỆU HIỆN TẠI</v-subheader> -->
                <!-- <v-card outlined rounded="lg" v-if="!form.updatingFamily">
                  <v-data-table></v-data-table>
                </v-card> -->
                <v-subheader class="text-subtitle-1 font-weight-bold">CẬP NHẬT THÔNG TIN</v-subheader>
                <v-card class="rounded-lg" outlined>
                  <v-card-title class="text-subtitle-1">
                    <v-spacer></v-spacer>
                    <v-btn @click="addFamilyDialog=true" small rounded dark color="teal darken-4" type="button"><v-icon left>mdi-plus</v-icon> Thêm</v-btn>
                  </v-card-title>
                  <v-divider class=""></v-divider>
                  <v-card-text class="pt-0 text--primary">
                    <div>
                      <v-data-table :items="form.familyMembers" :headers="familyMemberHeaders">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn color="error" icon dark @click="deleteFamily(item)"><v-icon>mdi-close-circle</v-icon></v-btn>
                        </template>
                        <template v-slot:[`item.doB`]="{ item }">
                            {{ $formatter.formatDate() }}
                        </template>
                      </v-data-table>
                      <v-dialog max-width="500" v-model="addFamilyDialog">
                        <v-card>
                          <v-card-title>
                            <v-spacer></v-spacer>
                            <v-icon color="error" @click="addFamilyDialog=false">mdi-close</v-icon>
                          </v-card-title>
                          <v-card-text>
                            <v-form v-model="isValid2" @submit.prevent="addFamily" class="my-0" ref="update_info_form_family" id="update_info_form_family">
                                <v-row class="my-0">
                                    <v-col cols="6">
                                        <label for="">Mối quan hệ</label>
                                        <v-select  dense outlined
                                          :items="[
                                            {text: 'Cha', value:'CHA'},
                                            {text: 'Mẹ', value:'ME'},
                                            {text: 'Con', value:'CON'},
                                            {text: 'Chồng', value:'CHONG'},
                                            {text: 'Vợ', value:'VO'},
                                            {text: 'Ông ngoại', value:'ONGNG'},
                                            {text: 'Ông nội', value:'ONGNO'},
                                            {text: 'Bà ngoại', value:'BANG'},
                                            {text: 'Bà nội', value:'BANO'},
                                            {text: 'Anh', value:'ANH'},
                                            {text: 'Chị', value:'CHI'},
                                            {text: 'Em', value:'EM'},
                                          ]"
                                          v-model="family.relationType" hide-details="auto" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6">
                                        <label for="">Họ & tên</label>
                                        <v-text-field v-model="family.memberName" dense outlined hide-details="auto" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <label for="">Mã NS trong TS (nếu có)</label>
                                        <v-text-field v-model="family.memberEmployeeCode" dense outlined hide-details="auto" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-text-field>
                                    </v-col>
                                    <!-- <v-col cols="6">
                                        <label for="">Ngày sinh</label>
                                        <v-text-field type="date" v-model="family.doB" dense outlined hide-details="auto" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <label for="">SĐT</label>
                                        <v-text-field v-model="family.phoneNumber" dense outlined hide-details="auto" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <label for="">CCCD</label>
                                        <v-text-field v-model="family.idNumber" dense outlined hide-details="auto" :rules="[v => !!v || 'Hãy nhập dữ liệu này']"></v-text-field>
                                    </v-col> -->
                                </v-row>
                            </v-form>
                          </v-card-text>
                          <v-card-actions class="justify-center">
                            <v-btn text dark color="teal darken-4" form="update_info_form_family" type="submit"> Lưu</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
          </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 px-6 grey lighten-5" style="border-bottom-left-radius: 24px; border-bottom-right-radius: 24px;">
          <v-btn color="grey darken-2" text class="font-weight-bold px-6 rounded-pill" @click="dialog=false, itemCode = null">
            HỦY BỎ / ĐÓNG
          </v-btn>
          
          <v-spacer></v-spacer>
          
          <template v-if="isConfirmView && !!itemCode && form.status === 0">
            <v-btn color="red darken-1" text class="rounded-pill px-6 font-weight-bold mr-2" @click="$emit('decline', form)">
                <v-icon left>mdi-close-circle-outline</v-icon> TỪ CHỐI
            </v-btn>
            <v-btn color="green darken-2" dark class="rounded-pill elevation-2 px-8 font-weight-bold" @click="$emit('accept', form)">
                <v-icon left>mdi-check-circle-outline</v-icon> XÁC NHẬN
            </v-btn>
          </template>

          <v-btn color="teal darken-4" type="submit" dark form="update_info_form" v-show="!itemCode" class="rounded-pill elevation-2 px-10 font-weight-bold">
              <v-icon left>mdi-send-circle-outline</v-icon> GỬI YÊU CẦU
          </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="imgViewer" max-width="1000">
      <v-card>
        <v-card-title>Hình ảnh 
          <v-spacer></v-spacer>
          <v-btn small @click="angle += 90" text color="primary"> Xoay</v-btn>
        </v-card-title>
        <v-img :src="imgSrc" :style="`transform: rotate(${angle}deg); transition: transform 0.3s ease;`"></v-img> 
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import http from '@/components/services/http-common'
import ApiServices from '@/components/services/ApiServices.js'
import InfoUpdateApi from './api.js'
import FileUpload from '@/components/FileUpload'
import {create } from './data'

export default {
  mounted() {
    // this.fetchDistrict()
    // this.fetchWard()

    //********Global Events Listener */
    this.$root.$on('openDialog', () => {
      this.dialog = true
      this.getEmployee()
    });
    
    this.$root.$on('editDialog', (data) => {
      this.dialog = true
      this.itemCode = data.id
      this.fetchData()
    });
    
    this.$root.$on('closeCreateDialog', () => {
      this.dialog = false
      this.itemCode = null
    });

  },
  beforeDestroy() {
    // this.dialog = false
    //********OFF Global Events Listener */
    this.$root.$off('openDialog');
    
    this.$root.$off('editDialog');
    this.$root.$off('closeCreateDialog');
  },
  props: {
    isConfirmView: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'file-upload': FileUpload
  },
  computed: {
    isRequireUpload() {
      const e = this.employee || {};
      const f = this.form || {};
      const dateStr = e.joinDate || e.hireDate || f.joinDate || f.hireDate;
      if (!dateStr) return false;
      return new Date(dateStr) > new Date('2026-03-31');
    },
    idPlaces() {
        let fixedData = [ "Cục Cảnh sát ĐKQL cư trú và DLQG về dân cư", "Cục Cảnh sát quản lý hành chính về trật tự xã hội", "Hàn Quốc"];
        let cityData = this.cities.map(x=>{return x.name});
        return fixedData.concat(cityData);
    }
  },
  data() {
    return create
  },
  watch: {
    noTaxNumber: {
      handler(val) {
        if(!val) {
          this.form.taxNumber=''
        }else {
          this.form.taxNumber='NO_NUMBER'
        }
      }
    },
    noInsuranceNumber: {
      handler(val) {
        if(!val) {
          this.form.insuranceNumber=''
        }else {
          this.form.insuranceNumber='NO_NUMBER'
        }
      }
    },

    idFrontImageFile: {
      handler(val) {
          this.$formatter.fileToBase64(val).then(r => {
              this.form.idFrontImageBase64.base64 = r.base64
              this.form.idFrontImageBase64.fileName = r.fileName
              this.form.idFrontImageBase64.type = r.type
              return r
          })
      }
    },
    
    idBackImageFile: {
      handler(val) {
          this.$formatter.fileToBase64(val).then(r => {
              this.form.idBackImageBase64.base64 = r.base64
              this.form.idBackImageBase64.fileName = r.fileName
              this.form.idBackImageBase64.type = r.type
              return r
          })
      }
    },
    bankImageFile: {
      handler(val) {
          this.$formatter.fileToBase64(val).then(r => {
              this.form.bankImageBase64.base64 = r.base64
              this.form.bankImageBase64.fileName = r.fileName
              this.form.bankImageBase64.type = r.type
              return r
          })
      }
    },
    
    maritalStatusImageFile: {
      handler(val) {
          this.$formatter.fileToBase64(val).then(r => {
            this.form.MaritalImageBase64.base64 = r.base64
            this.form.MaritalImageBase64.fileName = r.fileName
            this.form.MaritalImageBase64.type = r.type
            return r
          })
      }
    },
    religionImageFile: {
      handler(val) {
          this.$formatter.fileToBase64(val).then(r => {
            this.form.religionImageBase64.base64 = r.base64
            this.form.religionImageBase64.fileName = r.fileName
            this.form.religionImageBase64.type = r.type
            return r
          })
      }
    },
    // "form.city1Code": {
    //   handler(val) {
    //     if(!this.initForm) {
    //       this.form.district1Code = null
    //       this.form.ward1Code = null
    //     }
    //     this.fetchDistrict(val)
    //   }
    // },
    
    // "form.district2Code": {
    //   handler(val) {
    //     if(!this.initForm) {
    //       this.form.ward2Code = null
    //     }
    //     this.fetchWard(val)
    //   }
    // },
    
    "dialog": {
      handler(val) {
        if(val) {
          this.tab = null
          this.fetchCity()
          
          InfoUpdateApi.getAltCity().then(d => {
            this.altCities = d.data
          })
          this.fetchOrigin()
          this.fetchBank()
          //fetch edulvl, major,  uni
          
          ApiServices.fetchEducationLevel().then(r => {
            this.educationLevels = r.data
          })
          ApiServices.fetchUniversity().then(r => {
            this.universities = r.data
          })
          ApiServices.fetchEducationMajor().then(r => {
            this.educationMajors = r.data
          })
          ApiServices.fetchReligion().then(r => {
              this.religions = r.data
          })
          ApiServices.fetchEthnicity().then(r => {
              this.ethnicities = r.data
          })
        } else {
          //close dialog
          this.close()
        }
      }
    },
  },
  methods: {
    close() {
      Object.assign(this.form, this.defaultForm)
      this.noInsuranceNumber = false
      this.noTaxNumber = false
      this.itemCode = null
      this.isEditingPersonal = false
    },
    savePersonal() {
      if (!this.form.employeeName || this.form.gender === null || !this.form.birthday || !this.form.phoneNumber || !this.form.email) {
        alert("Vui lòng điền đầy đủ các thông tin cơ bản!");
        return;
      }
      if (!/.+@.+\..+/.test(this.form.email)) {
        alert("Email không hợp lệ!");
        return;
      }
      
      this.isSavingPersonal = true;
      let payload = {
        employeeName: this.form.employeeName,
        gender: this.form.gender,
        birthday: this.form.birthday,
        phoneNumber: this.form.phoneNumber,
        email: this.form.email
      };
      http.put(`infoUpdateRequests/${this.itemCode}/personal`, payload).then(res => {
        this.isEditingPersonal = false;
        this.$emit('refresh');
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.isSavingPersonal = false;
      });
    },
    saveIdInfo() {
      if (!this.form.idNumber || !this.form.idDate || !this.form.idPlace) {
        alert("Vui lòng điền đầy đủ thông tin căn cước công dân!");
        return;
      }
      this.isSavingIdInfo = true;
      let payload = {
        idNumber: this.form.idNumber,
        idDate: this.form.idDate,
        idPlace: this.form.idPlace,
        idFrontImageBase64: this.form.idFrontImageBase64,
        idBackImageBase64: this.form.idBackImageBase64,
      };
      http.put(`infoUpdateRequests/${this.itemCode}/idInfo`, payload).then(res => {
        this.isEditingIdInfo = false;
        this.$emit('refresh');
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.isSavingIdInfo = false;
      });
    },
    submitForm(){
      this.showTabValid = true
      this.$refs.update_info_form.validate()
      if(this.form.religionCode == 'TL' || this.form.religionCode == 'TCG' || this.form.religionCode == 'CG') {
        if(!this.religionImageFile) {
          alert("Hãy chụp giấy tờ tín ngưỡng bổ sung")
          return 0
        }
      }
      if(this.form.maritalStatus == 'KH') {
        if(!this.maritalStatusImageFile) {
          alert("Hãy chụp giấy chứng nhận kết hôn")
          return 0
        }
      }
      
      // if(this.form.bankNumber) {
      //   if(!this.bankImageFile) {
      //     alert("Hãy chụp ảnh chứng mình ngân hàng")
      //     return 0
      //   }
      // }
      if(this.isValid) {
        this.loading = true
        this.form.emergencyPhone = this.form.emergencyNumber
        return InfoUpdateApi.post(this.form).finally(() => {
          this.loading = false
        })
      }
    },

    fetchData() {
      this.initForm = true
      return InfoUpdateApi.get(this.itemCode).then(d => {
        const req = d.infoUpdateRequest
        this.originForm = {...d.infoUpdateRequestOriginal}
        this.form = {
            ...this.form,
            ...req,
            birthday: this.$formatter.formatDate(req.birthday, 'YYYY-MM-DD'),
            idDate: this.$formatter.formatDate(req.idDate, 'YYYY-MM-DD'),
            emergencyNumber: req.emergencyPhone
        }
        console.log("data:", this.form, this.originForm)

        if(this.form.taxNumber == 'NO_NUMBER'){
          this.noTaxNumber = true
        }
        if(this.form.insuranceNumber == 'NO_NUMBER'){
          this.noInsuranceNumber = true
        }
        this.form.familyMembers = d.employeeFamilyTemps
        
        if (this.form.city1Code) {
          ApiServices.fetchDistrictFromCity(this.form.city1Code).then(r => {
              this.districts = r.data
          })
        }
        if (this.form.district1Code) {
          ApiServices.fetchWardFromDistrict(this.form.district1Code).then(r => {
              this.wards = r.data
          })
        }

        if(this.form.city2Code) {
          ApiServices.fetchDistrictFromCity(this.form.city2Code).then(r => {
              this.districts2 = r.data
          })
        }

        if(this.form.district2Code)  {
          ApiServices.fetchWardFromDistrict(this.form.district2Code).then(r => {
              this.wards2 = r.data
          })
        }

        InfoUpdateApi.getAltCity().then(d => {
          console.log(d, '----------')
          this.altCities = d.data
        })
        if (this.form.newCityId) {
          InfoUpdateApi.getAltWard(this.form.newCityId).then(d => {
            this.altWards = d.data
            console.log(this.altWards, "ward 1")
          })
        }
        if (this.form.newCityId2) {
          InfoUpdateApi.getAltWard(this.form.newCityId2).then(d => {
            this.altWards2 = d.data
          })
        }

        // InfoUpdateApi.getFamilyTemp(this.itemCode).then(d => {
        //   this.form.familyMembers = d.data
        // })

      }).finally(() => {
        this.initForm = false
      })
    },

    getEmployee() {
      return InfoUpdateApi.getEmployee().then(d => {
        this.employee = d.data
        this.employee.birthday = this.$formatter.formatDate(this.employee.birthday, 'YYYY-MM-DD')
        this.employee.idDate = this.$formatter.formatDate(this.employee.idDate, 'YYYY-MM-DD')

        this.form.familyMembers = d.families
        this.form.employeeCode = this.employee.code
        this.form.email = this.employee.email
        this.hireDate = this.employee.hireDate
        this.form.employeeName = this.employee.name
        this.form.phoneNumber = this.employee.phoneNumber
        this.form.emergencyNumber = this.employee.emergencyNumber
        this.form.maritalStatus = this.employee.maritalStatus
        this.form.gender = this.employee.gender
        this.form.birthday = this.employee.birthday
        this.form.idNumber = this.employee.idNumber
        this.form.idDate = this.employee.idDate
        this.form.idPlace = this.employee.idPlace
        this.form.educationLevelCode = this.employee.educationLevelCode
        this.form.educationMajorCode = this.employee.educationMajorCode
        this.form.universityCode = this.employee.universityCode
        this.form.graduateStatus = this.employee.graduateStatus
        this.form.bankCode = this.employee.bankCode
        this.form.bankNumber = this.employee.bankNumber
        
        this.form.city1Code = this.employee.city1Code
        this.form.district1Code = this.employee.district1Code
        this.form.ward1Code = this.employee.ward1Code
        
        this.form.city2Code = this.employee.city2Code
        this.form.district2Code = this.employee.district2Code
        this.form.ward2Code = this.employee.ward2Code
        this.form.address2 = this.employee.address2

        this.form.city1Name = this.employee.city1Name
        this.form.district1Name = this.employee.district1Name
        this.form.ward1Name = this.employee.ward1Name
        this.form.address1 = this.employee.address1
        
        this.form.newCityId = this.employee.newCityId
        this.form.newWardId = this.employee.newWardId
        this.form.newCityId2 = this.employee.newCityId2
        this.form.newWardId2 = this.employee.newWardId2

        this.form.religionCode = this.employee.religionCode
        this.form.originCode = this.employee.originCode
        this.form.ethnicityCode = this.employee.ethnicityCode
        this.form.idFrontImageUrl = this.employee.idFrontImageUrl
        this.form.idBackImageUrl = this.employee.idBackImageUrl
        this.form.bankImageUrl = this.employee.bankImageUrl

        if (this.form.city1Code) {
          ApiServices.fetchDistrictFromCity(this.form.city1Code).then(r => {
              this.districts = r.data
          })
        }
        if (this.form.city2Code) {
          ApiServices.fetchDistrictFromCity(this.form.city2Code).then(r => {
              this.districts2 = r.data
          })
        }

        if (this.form.district1Code) {
          ApiServices.fetchWardFromDistrict(this.form.district1Code).then(r => {
              this.wards = r.data
          })
        }
        if (this.form.district2Code) {
          ApiServices.fetchWardFromDistrict(this.form.district2Code).then(r => {
              this.wards2 = r.data
          })
        }

        if (this.form.newCityId) {
          InfoUpdateApi.getAltWard(this.form.newCityId).then(d=> {
            this.altWards = d.data
          })
        }
        if (this.form.newCityId2) {
          InfoUpdateApi.getAltWard(this.form.newCityId2).then(d=> {
            this.altWards2 = d.data
          })
        }
        // this.fetchAltWards1(true)
        // this.fetchAltWards2(true)


      })
    },
    
    fetchOrigin() {
      return ApiServices.fetchOrigin().then(r => {
          this.origins = r.data
      })
    },
    fetchCity() {
        return ApiServices.fetchCity().then(r=> {
            this.cities = r.data.data
            this.cities2 = r.data.data
        })
    },
    fetchDistrict(id) {
      this.wards = []
      this.form.district1Code = null
      this.form.ward1Code = null
      if (id) {
        ApiServices.fetchDistrictFromCity(id).then(r => {
            this.districts = r.data
        })
      } else {
        this.districts = []
      }
    },
    
    fetchDistrict2(id) {
      this.wards2 = []
      this.form.district2Code = null
      this.form.ward2Code = null
      if (id) {
        ApiServices.fetchDistrictFromCity(id).then(r => {
            this.districts2 = r.data
        })
      } else {
        this.districts2 = []
      }
    },

    fetchAltWards1(init=false) {
      if(!init) {
        this.form.newWardId = null
        this.altWards = []
      }
      if (this.form.newCityId) {
        InfoUpdateApi.getAltWard(this.form.newCityId).then(d=> {
          this.altWards = d.data
        })
      }
    },
    fetchAltWards2(init=false) {
      if(!init) {
        this.form.newWardId2 = null
        this.altWards2 = []
      }
      if (this.form.newCityId2) {
        InfoUpdateApi.getAltWard(this.form.newCityId2).then(d=> {
          this.altWards2 = d.data
        })
      }
    },

    // fetchDistrict(id) {
    //     ApiServices.fetchDistrictFromCity(id).then(r => {
    //         this.districts = r.data
    //     })
    // },

    fetchWard(id) {
      this.form.ward1Code = null
      if (id) {
        ApiServices.fetchWardFromDistrict(id).then(r => {
            this.wards = r.data
        })
      } else {
        this.wards = []
      }
    },
    
    fetchWard2(id) {
      this.form.ward2Code = null
      if (id) {
        ApiServices.fetchWardFromDistrict(id).then(r => {
            this.wards2 = r.data
        })
      } else {
        this.wards2 = []
      }
    },
    
    fetchBank() {
        return ApiServices.fetchBank().then(r => {
            this.banks = r.data
        })
    },
    addFamily() {
      this.form.familyMembers.push({...this.family})
      Object.assign(this.family, this.familyDefault)
      this.$refs.update_info_form_family.resetValidation()
      this.addFamilyDialog = false
    },
    deleteFamily(item) {
      this.form.familyMembers = this.form.familyMembers.filter(x=>x.memberName != item.memberName && x.idNumber != item.idNumber)
    }
  },
}
</script>